/**
 * Android の Chrome でだけ、viewport に `viewport-fit=cover` を足す（PRODUCT_DEV-981）。
 *
 * ## なぜ要るか
 *
 * Chrome 135 以降の Android（小さい画面）は、下へスクロールするとブラウザ下の帯（chin）を
 * 引っ込め、**ページを画面の下端＝ジェスチャーナビの裏まで広げる**（edge-to-edge）。
 * `position: fixed; bottom: 0` のグロナビはそれに付いて下がり、ナビバーの裏に半分隠れたままになる
 * （Galaxy S25 Ultra の実機で「スクロールすると一緒に下がって下がったまま」と指摘）。
 * 公式の移行ガイド: https://developer.chrome.com/docs/css-ui/edge-to-edge
 *
 * 直すには、グロナビの位置を `env(safe-area-inset-bottom)` で持ち上げる（`.fixed-bottom-bar`・index.css）。
 * ただし env() の safe-area は **`viewport-fit=cover` のページでしか 0 以外を返さない**。
 *
 * ## なぜ Android だけか
 *
 * `viewport-fit=cover` は iPhone ではページをホームバーの裏まで広げる指定で、画面下に貼り付く
 * ほかの部品（シート・保存バーなど。safe-area を見ていないものがある）の見え方が変わる。
 * iPhone ではこのズレは確かめておらず、変える理由がまだ無いので、影響を Android に閉じる。
 * Android ではこの指定が無くても chin が引っ込めばページはナビの裏まで広がる（ガイドのとおり）ので、
 * 足しても見え方は悪くならない。
 *
 * すでに付いているときは何もしない（二重に足さない）。
 */
export const applyAndroidViewportFit = (doc: Document, userAgent: string): void => {
  if (!/Android/i.test(userAgent)) return;
  const meta = doc.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta || /viewport-fit\s*=/.test(meta.content)) return;
  meta.content = `${meta.content}, viewport-fit=cover`;
};
